import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const o=i("chad",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#C60C30" />
            <path
                d="M0 4.5H16V20.5H0V4.5Z"
                fill="#FECB00" />
            <path
                d="M0 4.5H8V20.5H0V4.5Z"
                fill="#002664" />
        </svg>
    `),a=i("chad_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_96610)">
                <path
                    d="M0 0.5H24V24.5H0V0.5Z"
                    fill="#C60C30" />
                <path
                    d="M0 0.5H16V24.5H0V0.5Z"
                    fill="#FECB00" />
                <path
                    d="M0 0.5H8V24.5H0V0.5Z"
                    fill="#002664" />
            </g>
            <defs>
                <clipPath id="clip0_19477_96610">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as Chad,a as ChadRounded};
